// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"851":"e2107020","2624":"bad62be4","2942":"d14995b9","3443":"3f2c0710","4955":"fe56a3a2","8845":"043102cc","8978":"fe56a3a2"}[chunkId] + ".chunk.css";
};